import { IConexaResponse } from '@/@types/generic-types'
import httpClient from '@/services/httpClient'
import { BiometryStartResponse } from './types'

const normalizeCpf = (cpf: string) => {
  return cpf.replace(/\D/g, '')
}

export class BiometryService {
  static async biometryStart(callbackUri: string) {
    const { data } = await httpClient.post<
      IConexaResponse<BiometryStartResponse>
    >('/biometry/start', {
      callbackUri,
    })
    return data?.object
  }

  static async biometryStartPatient(
    callbackUri: string,
    cpf: string,
    captcha: string,
  ) {
    const normalizedCpf = normalizeCpf(cpf)

    const { data } = await httpClient.post<
      IConexaResponse<BiometryStartResponse>
    >(
      `/biometry/patient/cpf/${normalizedCpf}/start`,
      {
        callbackUri,
      },
      {
        headers: {
          captcha,
        },
      },
    )
    return data?.object
  }

  static async getBiometryResult(
    cpf: string,
    proccessId: string,
    captcha: string,
  ) {
    const normalizedCpf = normalizeCpf(cpf)

    const { data } = await httpClient.get<
      IConexaResponse<BiometryStartResponse>
    >(`/biometry/patient/cpf/${normalizedCpf}/result/${proccessId}`, {
      headers: {
        captcha,
      },
    })
    return data?.object
  }
}
